bcn.characterLimit = (function () {

  'use strict';

  function countChars (textArea, remainingEl, limit) {
    var textAreaVal = textArea.val();
    var textLength = textAreaVal.length;

    if (textLength > limit ) {
      textArea.val(textAreaVal.substr(0, limit));
      remainingEl.text(0);
      return;
    }

    remainingEl.text(limit - textLength);
  }

  function characterLimit () {

    if (!$('[data-char-limit]').length) return;

    var textArea = $('[data-char-limit]');
    var textAreaVal;
    var limit = parseInt(textArea.data('char-limit'), 10);
    var textLength = 0;
    var remainingEl;

    textArea.after('<div class="js-chars-remaining"><span>' + limit + '</span> characters remaining</div>');
    remainingEl = $('.js-chars-remaining span');

    countChars(textArea, remainingEl, limit);

    textArea.on('keyup focus', function () {
      countChars(textArea, remainingEl, limit);
    });
  }

  return {
    init: function () {
      characterLimit();
    }
  };

})();
